import React from 'react';
import Recomende from './containers/RecomendeContainer';


const RecomendeApp = () => <Recomende />;

export default RecomendeApp;
